import Merchants from '../features/merchants';

export const MerchantsPage = () => <Merchants />;
